import type { SVGProps } from "react";
const SvgIconProduct = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="m499.5 560.35-81 82.32a25 25 0 0 1-30.47 4l-148.71-87.23v98.24a25 25 0 0 0 12.35 21.57L499.5 824.67ZM636 646.7a25 25 0 0 1-30.47-4l-81-82.32v264.29l247.8-145.42a25 25 0 0 0 12.35-21.57v-98.24Z" />
    <path d="M499.35 199.42 245 348.66a49.8 49.8 0 0 0-10.33 8L137 456a10 10 0 0 0 2.07 15.64l261.61 153.5L512 512 264 366.49 512 221l248 145.5L512 512l111.32 113.14 261.61-153.51A10 10 0 0 0 887 456l-97.69-99.28a49.8 49.8 0 0 0-10.33-8l-254.33-149.3a25 25 0 0 0-25.3 0" />
  </svg>
);
export default SvgIconProduct;
